module.exports = "<h1 id=\"图标--ae-icon\">图标  ae-icon</h1>\n<blockquote>\n<p>使用<code>ant-design-vue</code>的<code>icon</code>组件代码</p>\n</blockquote>\n";